import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { formatDate, quotationSignatureType } from "../../_helpers";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2, LinkColumnV2,} from "../../components/DataGridV2/DataColumnsV2";


export const getQuotationColumns = ({
  t,
  i18n,
  handleCellFilter,
  apiRef,
  handleCellSort,
  keyPrefix,
  theme
}) => {
  const getOptions = getGridContextMenuList({
    handleCellSort, sortKey: LOCAL_STORAGE_GRID_KEYS.QUOTATIONS_COLUMN_SORT[keyPrefix],
    handleCellFilter, filterKey: LOCAL_STORAGE_GRID_KEYS.QUOTATIONS_COLUMN_FILTER[keyPrefix],
    i18n,
    t,
    apiRef,
    getValueForCopy: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "quotationSignatureType":
          text = t(`db.domain.ondertekening.${rowData.quotationSignatureType}`)
          break;
          case "createdOn":
          text = formatDate(new Date(rowData?.createdOn), true, "-", false)
          break;
          case "closingDate":
          text = formatDate(new Date(rowData?.closingDate),)
          break;
          case "isSigningStarted":
           text = rowData[extraData.fieldName] ? t("general.yes") : t("general.no")
           break;
         default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    }
  })

  return [
    {
      field: "quoteNo",
      download: true,
      headerName: t('buyersGuide.quotation.number'),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LinkColumnV2
            to={ "offertes/"+ params?.row?.id }
            label={rowData.quoteNo}
            cellSubMenuOptions={{ options: getOptions({ field: "quoteNo", isQuickFilterDisplay: Boolean(rowData?.quoteNo.toString()) }), extraData: { fieldName: "quoteNo" } }} 
            request={rowData}
          />
        )
      },
    },
    {
      field: "createdOn",
      headerName: t('general.creationDate'),
      flex: 1,
      minWidth: 90,
      type: "dateTime",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2
          label={rowData?.createdOn ? formatDate(new Date(rowData?.createdOn), true, "-", false) : ""}
          cellSubMenuOptions={{ options: getOptions({ field: "createdOn", isQuickFilterDisplay: rowData?.createdOn }), extraData: { fieldName: "createdOn", type: "dateTime" } }}
          request={rowData}
        />
      },
    },
    {
      field: "buildingNoIntern",
      download: true,
      headerName: t("general.object"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.buildingNoIntern}
            cellSubMenuOptions={{ options: getOptions({ field: "buildingNoIntern", isQuickFilterDisplay: Boolean(rowData.buildingNoIntern) }), extraData: { fieldName: "buildingNoIntern" } }}
            request={rowData}
          />
        )
      },
    },
    {
      field: "quotationSignatureType",
      download: true,
      headerName: t("general.signature"),
      flex: 1,
      type: 'singleSelect',
      minWidth: 140,
      valueOptions: Object.values(quotationSignatureType).map((quotationSignatureType) => ({ value: quotationSignatureType.toString(), label: t(`db.domain.ondertekening.${quotationSignatureType}`) })),
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={t(`db.domain.ondertekening.${rowData.quotationSignatureType}`)}
            cellSubMenuOptions={{ options: getOptions({ field: "quotationSignatureType", isQuickFilterDisplay: Boolean(rowData.quotationSignatureType) }), extraData: { fieldName: "quotationSignatureType", type: "singleSelect" } }}
            request={rowData}
          />
        )
      },
    },
    {
      field: "closingDate",
      download: true,
      type: "date",
      valueGetter: (params) => {
        const rowData = params.row;
        if (!rowData?.closingDate) return "";
        return new Date(rowData?.closingDate);
      },
      headerName: t("buyersGuide.closingDate"),
      minWidth: 90,
      flex: 1,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            date={rowData.closingDate}
            cellSubMenuOptions={{ options: getOptions({ field: "closingDate", isQuickFilterDisplay: Boolean(rowData.closingDate) }), extraData: { fieldName: "closingDate", type: "date" } }}
            request={rowData}
          />
        )
      },
    },
    {
      field: "isSigningStarted",
      download: true,
      headerName: t("buyersGuide.quotation.list.signingStarted"),
      flex: 1,
      minWidth: 140,
      type: "boolean",
      renderCell: (params) => {
        const rowData = params.row;
        const isSigningStarted = rowData.isSigningStarted === true;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={isSigningStarted ? t("general.yes") : t("general.no")}
            color={isSigningStarted ? theme.palette.success.main : theme.palette.error.main}
            cellSubMenuOptions={{ options: getOptions({ field: "isSigningStarted", isQuickFilterDisplay: typeof rowData.isSigningStarted === "boolean" }), extraData: { fieldName: "isSigningStarted", type: "boolean" } }}
            request={rowData}
          />
        )
      },
    },
    {
      field: "documentId",
      download: true,
      headerName: t("general.documentId"),
      flex: 1,
      type:"number",
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.documentId}
            request={rowData}
            cellSubMenuOptions={{ options: getOptions({ field: "documentId", isQuickFilterDisplay: Boolean(rowData.documentId?.toString()) }), extraData: { fieldName: "documentId",type:'number' } }}

          />
        )
      },
    },
    {
      field: "documentStatus",
      download: true,
      headerName: t("buyersGuide.quotation.list.documentStatus"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.documentStatus}
            request={params.row}
            cellSubMenuOptions={{ options: getOptions({ field: "documentStatus", isQuickFilterDisplay: Boolean(rowData.documentStatus) }), extraData: { fieldName: "documentStatus"} }}
          />
        )
      },
    },
    {
      field:'optionsCount',
      download: true,
      headerName:t('buyersGuide.options.individualOption.chosenOption'),
      type:"number",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        return (
          <LabelColumnV2
            label={rowData.optionsCount}
            cellSubMenuOptions={{ options: getOptions({ field: "optionsCount", isQuickFilterDisplay: Boolean(rowData.optionsCount?.toString()) }), extraData: { fieldName: "optionsCount" ,type:'number'} }}
            request={rowData}
          />
        )
      },
    },
    {
      field: "id",
      headerName: t("general.primaryKey"),
      download: true,
      print: false,
      filterable: false,
      sortable: false,
      hidden: true,
    },
  ];
};

export const getQuotationHiddenColumns = (t) => {
  return [
    {
      field: "numberOfSignatories",
      download: true,
      headerName: t("buyersGuide.quotation.list.numberOfSignatures"),
    },
    {
      field: "createdBy",
      download: true,
      headerName: t("general.createdBy"),
    },
    {
      field: "modifiedOn",
      download: true,
      headerName: t("general.modifiedOn"),
    },
    {
      field: "modifiedBy",
      download: true,
      headerName: t("general.modify"),
    }

  ]
}

export const getQuotationsGridNavigationItem = (t) => {
  const to = "/offertes"
  // TODO: need to update this once data table created
  return {
    breadCrumbs: [{ breadCrumbTitle: t('buyersGuide.quotations'), title: t('buyersGuide.quotations'), to }],
    tabs: [{title:t('general.list') , to}]
  }
}

